/* eslint-disable no-console */

import React, { useEffect, useState, useRef } from 'react'
import { DropdownMenu, Checkbox, Button, Alert } from '@paypalcorp/pp-react'
import { TextInputWrapper } from '../components/pp-react-wrappers'
import formContent from '../components/content/signup/form.en-XC.yaml'
import { getRequest, postRequest } from '../utils/request'

export default function SignupForm({ auto = false }) {
  const [formState, setFormState] = useState('initial')
  const [buttonState, setButtonState] = useState('initial')
  const [countries, setCountries] = useState([])
  const elqFormRef = useRef(null)

  const [formData, setFormData] = useState({
    email: '',
    first_name: '',
    last_name: '',
    country: 'US',
    company: '',
    terms: false,
  })

  const [formErrors, setFormErrors] = useState({
    email: false,
    first_name: false,
    last_name: false,
    country: false,
    company: false,
    terms: false,
  })

  const [elqFormData, setElqFormData] = useState({
    elqAction: '',
    elqFormName: '',
    elqSiteId: '',
    elqTrackId: '',
  })

  const termsAndConditions = (
    <p>
      {formContent.content.privacy_statement1}
      <a
        href="https://www.paypal.com/us/webapps/mpp/ua/privacy-full"
        className="terms_and_conditions_link dx-external-href"
        target="_blank"
        rel="noreferrer"
      >
        {' '}
        {formContent.content.privacy_statement2}
      </a>
      {formContent.content.privacy_statement3}
    </p>
  )

  const getCountries = async () => {
    try {
      const { data } = await getRequest('/apis/countries')
      setCountries(
        data.countries.map((c) => {
          return { value: c.countryCode, label: c.countryName }
        }),
      )
    } catch (err) {
      const countries = [{ value: 'US', label: 'United States' }]
      setCountries(countries)
      console.log(err)
    }
  }

  const onFormChange = (field, value) => {
    setFormData({ ...formData, [field]: value })
    if (formErrors[field] === true) {
      setFormErrors({ ...formErrors, [field]: false })
    }
  }

  const submitSignup = async () => {
    setFormState('processing')
    setButtonState('processing')

    try {
      // clear form errors
      setFormErrors({
        email: false,
        first_name: false,
        last_name: false,
        country: false,
        company: false,
        terms: false,
      })

      const validationResponse = await postRequest('/apis/signup', formData)

      if (
        validationResponse.data &&
        validationResponse.data.msg === 'VALIDATED' &&
        validationResponse.data.elqFormName
      ) {
        // Populate the Eloqua html form and then submit it
        const { elqAction, elqFormName, elqSiteId, elqTrackId } =
          validationResponse.data

        setElqFormData({ elqAction, elqFormName, elqSiteId, elqTrackId })

        elqFormRef.current.submit()
      } else {
        setFormState('error')
        console.log('submitSignup()', 'Error', 'validation response invalid')
      }
    } catch (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log('submitSignup()', error.response.data)
        if (error.response.data && error.response.data.errors) {
          const hasErrors = {}
          //update error
          error.response.data.errors.forEach((subError) => {
            if (subError.param) {
              hasErrors[subError.param] = true
            }
          })

          setFormErrors(hasErrors)
        }
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        setFormState('error')
        console.log('submitSignup()', error.request)
      } else {
        // Something happened in setting up the request that triggered an Error
        setFormState('error')
        console.log('submitSignup()', 'Error', error.message)
      }
    }
    setButtonState('initial')
  }

  useEffect(() => {
    ;(async function () {
      await getCountries()
      // signupScript()
    })()
  }, [])

  return (
    <div className="signup-content">
      {(formState === 'success' || auto) && (
        <Alert type="success">{formContent.content.successfull_signup}</Alert>
      )}

      {formState === 'error' && (
        <Alert type="error">{formContent.content.failed_signup}</Alert>
      )}

      {formState !== 'success' && !auto && (
        <React.Fragment>
          <div className="ppvx_container--form">
            <div className="ppvx_row">
              <div className="ppvx_col-form--half">
                <TextInputWrapper
                  nameValue="first_name"
                  errorPresent={
                    formErrors.first_name.isTouched &&
                    (formErrors.first_name.isValid ? false : true)
                  }
                  errorTextForFpti={formContent.content.firstname_error}
                  name="first_name"
                  label={formContent.content.firstname_label}
                  value={formData.first_name}
                  onChange={(e) => {
                    onFormChange(e.target.name, e.target.value)
                  }}
                  helperText="​"
                  errorText={
                    formErrors.first_name
                      ? formContent.content.firstname_error
                      : ''
                  }
                />
              </div>
              <div className="ppvx_col-form--half">
                <TextInputWrapper
                  nameValue="last_name"
                  errorPresent={
                    formErrors.last_name.isTouched &&
                    (formErrors.last_name.isValid ? false : true)
                  }
                  errorTextForFpti={formContent.content.lastname_error}
                  name="last_name"
                  label={formContent.content.lastname_label}
                  value={formData.last_name}
                  onChange={(e) => {
                    onFormChange(e.target.name, e.target.value)
                  }}
                  helperText="​"
                  errorText={
                    formErrors.last_name
                      ? formContent.content.lastname_error
                      : ''
                  }
                />
              </div>
            </div>
            <div className="ppvx_row">
              <div className="ppvx_col-form--half">
                <TextInputWrapper
                  nameValue="email"
                  errorPresent={
                    formErrors.email.isTouched &&
                    (formErrors.email.isValid ? false : true)
                  }
                  errorTextForFpti={formContent.content.emailaddress_error}
                  name="email"
                  label={formContent.content.emailaddress_label}
                  value={formData.email}
                  onChange={(e) => {
                    onFormChange(e.target.name, e.target.value)
                  }}
                  helperText="​"
                  errorText={
                    formErrors.email
                      ? formContent.content.emailaddress_error
                      : ''
                  }
                />
              </div>
              <div className="ppvx_col-form--half">
                <TextInputWrapper
                  nameValue="company"
                  errorPresent={
                    formErrors.company.isTouched &&
                    (formErrors.company.isValid ? false : true)
                  }
                  errorTextForFpti={formContent.content.company_error}
                  name="company"
                  label={formContent.content.company_label}
                  value={formData.company}
                  onChange={(e) => {
                    onFormChange(e.target.name, e.target.value)
                  }}
                  helperText="​"
                  errorText={
                    formErrors.company ? formContent.content.company_error : ''
                  }
                />
              </div>
            </div>
            <div className="ppvx_row">
              <div className="ppvx_col-form--half">
                <DropdownMenu
                  name="country"
                  label={formContent.content.country_label}
                  value={formData.country}
                  options={countries}
                  onChange={(e) => {
                    onFormChange(e.target.name, e.target.value)
                  }}
                  helperText="​"
                  errorText={
                    formErrors.country ? formContent.content.country_error : ''
                  }
                />
              </div>
            </div>
            <div className="ppvx_row">
              <div className="ppvx_col-form--full">
                <Checkbox
                  name="terms"
                  label={termsAndConditions}
                  value={formData.terms}
                  onChange={(e) => {
                    onFormChange(e.target.name, e.target.checked)
                  }}
                  className="ppvx_terms"
                  helperText="​"
                  error={formErrors.terms}
                  errorText={
                    formErrors.terms
                      ? formContent.content.terms_and_conditions
                      : ''
                  }
                />
              </div>
            </div>
            <div className="ppvx_row">
              <div className="ppvx_col-form--full signup-form">
                <Button size="lg" onClick={submitSignup} btnState={buttonState}>
                  {formContent.content.signupbutton_label}
                </Button>
              </div>
            </div>
          </div>
          {/*
              Hidden Form for Eloqua to submit after validation
              submits by useRef elqFormRef.current.submit()
           */}
          <form
            ref={elqFormRef}
            action={elqFormData.elqAction}
            method="POST"
            data-testid="elq-form"
          >
            <input
              type="hidden"
              name="elqFormName"
              value={elqFormData.elqFormName}
            />
            <input
              type="hidden"
              name="elqSiteId"
              value={elqFormData.elqSiteId}
            />
            <input
              type="hidden"
              name="elqTrackId"
              value={elqFormData.elqTrackId}
            />
            <input type="hidden" name="firstName" value={formData.first_name} />
            <input type="hidden" name="lastName" value={formData.last_name} />
            <input type="hidden" name="emailAddress" value={formData.email} />
            <input type="hidden" name="company" value={formData.company} />
            <input type="hidden" name="country" value={formData.country} />
          </form>
        </React.Fragment>
      )}
    </div>
  )
}
